import React from 'react';
import { Tag } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { routes, subRoutes } from '../../utils/constants/routes';
import {
  contractsStatuses,
  contractsTypes
} from '../../utils/constants/tagColors';

const useColumns = () => {
  const { t } = useTranslation();
  const contractColumns = (setVisible) => {
    return [
      {
        title: t('contracts.column.number'),
        render: (record) => {
          return (
            <Link
              to={`${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CONTRACTS}/show/${record._id}`}
              onClick={() => setVisible(false)}
            >
              {record.number}
            </Link>
          );
        },
        sorter: true
      },
      {
        title: t('contracts.column.client'),
        render: (record) => (
          <Link
            to={`${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CLIENTS}/show/${record.customer?._id}`}
            onClick={() => setVisible(false)}
          >
            {`${record.customer?.last_name} ${record.customer?.first_name}`}
          </Link>
        ),
        sorter: true
      },
      {
        title: t('contracts.column.contractType'),
        dataIndex: 'type',
        key: 'type',
        render: (contractType) => (
          <Tag color={contractsTypes[contractType]}>
            {t(`contracts.tags.${contractType}`)}
          </Tag>
        ),
        sorter: true,
        width: 80
      },
      {
        title: t('contracts.column.start_date'),
        dataIndex: 'effective_date',
        render: (effective_date) =>
          effective_date && moment(effective_date).format('L'),
        sorter: true
      },
      {
        title: t('contracts.form.contract_status'),
        dataIndex: 'status',
        key: 'status',
        render: (status) => (
          <Tag color={contractsStatuses[status]}>
            {t(`contracts.tags.${status}`)}
          </Tag>
        ),
        sorter: true
      }
    ];
  };

  const getColumns = (purpose, setVisible) => {
    if (purpose === 'contracts') return contractColumns(setVisible);
    return null;
  };

  return {
    getColumns
  };
};

export default useColumns;
